import React, { useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { CheckCircle, Package, Mail, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
export function OrderConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    isAuthenticated
  } = useAuth();
  const state = location.state as {
    orderNumber?: string;
    total?: number;
    hasAccount?: boolean;
  } | null;
  useEffect(() => {
    if (!state?.orderNumber) navigate('/');
  }, [state, navigate]);
  if (!state?.orderNumber) return null;
  const showOrdersLink = isAuthenticated || state.hasAccount;
  return <div className="min-h-[80vh] flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-587">
      <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-sm border border-gray-100 text-center" data-id="element-588">
        <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-589">
          <CheckCircle className="w-10 h-10 text-green-500" data-id="element-590" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-591">
          Payment Successful!
        </h1>
        <p className="text-gray-500 mb-6" data-id="element-592">
          Thank you for your purchase. Your order has been received and is being
          processed.
        </p>

        <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left border border-gray-100 space-y-4" data-id="element-593">
          <div className="flex justify-between items-center pb-4 border-b border-gray-200" data-id="element-594">
            <span className="text-sm text-gray-500" data-id="element-595">Order Number</span>
            <span className="font-semibold text-gray-900" data-id="element-596">
              {state.orderNumber}
            </span>
          </div>
          <div className="flex justify-between items-center pb-4 border-b border-gray-200" data-id="element-597">
            <span className="text-sm text-gray-500" data-id="element-598">Total Amount</span>
            <span className="font-semibold text-gray-900" data-id="element-599">
              MVR {state.total?.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-600">
            <span className="text-sm text-gray-500" data-id="element-601">Payment Method</span>
            <span className="font-medium text-gray-900 flex items-center gap-1.5" data-id="element-602">
              <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-603"></div>
              BML Gateway
            </span>
          </div>
        </div>

        <div className="space-y-4 text-left mb-8" data-id="element-604">
          <h3 className="font-medium text-gray-900" data-id="element-605">What happens next?</h3>
          <div className="flex gap-3 text-sm text-gray-600" data-id="element-606">
            <Mail className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-607" />
            <p data-id="element-608">
              You will receive an order confirmation email with details of your
              order.
            </p>
          </div>
          <div className="flex gap-3 text-sm text-gray-600" data-id="element-609">
            <Package className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-610" />
            <p data-id="element-611">
              We'll notify you when your order is ready for delivery or pickup.
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-612">
          {showOrdersLink && <Link to="/account/orders" className="w-full bg-white text-gray-900 border border-gray-300 py-3 px-4 rounded-xl font-medium hover:bg-gray-50 transition-colors flex justify-center items-center gap-2" data-id="element-613">
              View Order in My Account
            </Link>}
          <Link to="/shop" className="w-full bg-red-600 text-white py-3.5 px-4 rounded-xl font-medium hover:bg-red-700 transition-colors flex justify-center items-center gap-2" data-id="element-614">
            Continue Shopping <ArrowRight className="w-4 h-4" data-id="element-615" />
          </Link>
        </div>
      </div>
    </div>;
}